import { useEffect } from 'react';

export interface Metadata {
  title: string;
  description: string;
  canonical: string;
  robots: string;
  image: string;
  structuredData?: unknown;
}

export const applyMetadata = (metadata: Metadata) => {
  document.title = metadata.title;
  const set = (selector: string, tag: string, attributes: Record<string, string>) => {
    let element = document.head.querySelector(selector);
    if (!element) { element = document.createElement(tag); document.head.appendChild(element); }
    Object.entries(attributes).forEach(([key, value]) => element!.setAttribute(key, value));
  };
  set('link[rel="canonical"]', 'link', { rel: 'canonical', href: metadata.canonical });
  Object.entries({ description: metadata.description, robots: metadata.robots, 'twitter:card': 'summary_large_image', 'twitter:title': metadata.title, 'twitter:description': metadata.description, 'twitter:image': metadata.image }).forEach(([name, content]) => set(`meta[name="${name}"]`, 'meta', { name, content }));
  Object.entries({ title: metadata.title, description: metadata.description, url: metadata.canonical, type: 'website', image: metadata.image }).forEach(([name, content]) => set(`meta[property="og:${name}"]`, 'meta', { property: `og:${name}`, content }));
  document.getElementById('page-schema')?.remove();
  if (metadata.structuredData) {
    const script = document.createElement('script');
    script.id = 'page-schema'; script.type = 'application/ld+json';
    script.textContent = JSON.stringify(metadata.structuredData).replace(/</g, '\\u003c');
    document.head.appendChild(script);
  }
};

export const useMetadata = (metadata: Metadata | null) => {
  const serialized = JSON.stringify(metadata);
  useEffect(() => { if (serialized !== 'null') applyMetadata(JSON.parse(serialized)); }, [serialized]);
};

